import GeoCoordinates from '../../../../model/GeoCoordinates';

const makeGeoCoordinatesFromPoints = (pointArray) => pointArray.map(({ x, y }) => new GeoCoordinates(x, y));

export default makeGeoCoordinatesFromPoints;
